module.exports = __webpack_public_path__ + "static/media/cart.2a7d1f00.svg";